import { playerStorage } from '../../storages';
import { PlayerEvent } from '../../types';

export function handleUIPausePlay(e: PlayerEvent) {
  const { player } = playerStorage.getPlayer();
  // update playerStorage.isPlayBackPaused only after user interaction (default false)
  playerStorage.setIsPlayBackPaused(e.type === player.Event.UI.USER_CLICKED_PAUSE);
}
